import React, { useState, useEffect } from 'react'
import { Card, Row, Col, Form, Button, Spinner } from 'react-bootstrap'
import ClockTimePicker from '../../../../GlobalModules/Utility/Components/ClockTimePicker'
import { useHistory, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faArrowLeft, 
    faSave, 
    faTimes, 
    faCalendar, 
    faClock, 
    faUser, 
    faEnvelope, 
    faPhone, 
    faUsers, 
    faAlignLeft,
    faTag
} from '@fortawesome/free-solid-svg-icons'
import * as BookingEventsController from '../Controller/BookingEventsController'
import Utility from '../../../../GlobalModules/Utility/Utility'
import ErrorBoundary from '../../../../GlobalModules/Utility/Components/ErrorBoundary';

const EVENT_TYPES = [
  { value: 'BOOKING', label: 'Booking' },
  { value: 'EVENT', label: 'Event' },
  { value: 'PARTY', label: 'Party' },
  { value: 'MEETING', label: 'Meeting' }
]

const EditBooking = (props) => {
  const history = useHistory()
  const { slack, lng } = useParams()
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(true)
  const [form, setForm] = useState({
    event_type: 'BOOKING',
    start_date: '',
    start_time: '',
    start_time_24: '',
    start_h: '12',
    start_m: '00',
    start_ap: 'AM',
    end_date: '',
    end_time: '',
    end_time_24: '',
    end_h: '12',
    end_m: '00',
    end_ap: 'AM',
    name: '',
    email: '',
    phone: '',
    no_of_persons: '',
    description: ''
  })
  const [errors, setErrors] = useState({})

  // Helper function to extract date and time from "YYYY-MM-DD HH:mm:ss" format
  const parseDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return { date: '', time: '' }
    
    // If it contains a space, split by space (format: "2026-07-02 10:30:00")
    if (dateTimeStr.includes(' ')) {
      const parts = dateTimeStr.split(' ')
      return { date: parts[0], time: parts[1] ? parts[1].substring(0, 5) : '' }
    }
    
    // If it contains 'T', split by T (ISO format)
    if (dateTimeStr.includes('T')) {
      const parts = dateTimeStr.split('T')
      return { date: parts[0], time: parts[1] ? parts[1].substring(0, 5) : '' }
    }
    
    // If it's just a date
    if (dateTimeStr.includes('-')) {
      return { date: dateTimeStr, time: '' }
    }
    
    return { date: dateTimeStr, time: '' }
  }

  // Fetch booking data
  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true)
        const res = await BookingEventsController.getBookingDetailApi(slack)
        console.log('API Response:', res)
        if (res.success) {
          const data = res.data?.data || res.data
          console.log('Booking Data:', data)
          if (data) {
            // Parse start date and time
            const startParsed = parseDateTime(data.start_date)
            const endParsed = parseDateTime(data.end_date)
            
            console.log('Start Parsed:', startParsed)
            console.log('End Parsed:', endParsed)

            setForm({
              event_type: data.event_type || 'BOOKING',
              start_date: startParsed.date || '',
              start_time: startParsed.time ? to12Hour(startParsed.time) : '',
              start_time_24: startParsed.time || '',
              start_h: '12',
              start_m: '00',
              start_ap: 'AM',
              end_date: endParsed.date || '',
              end_time: endParsed.time ? to12Hour(endParsed.time) : '',
              end_time_24: endParsed.time || '',
              end_h: '12',
              end_m: '00',
              end_ap: 'AM',
              name: data.name || '',
              email: data.email || '',
              phone: data.phone || '',
              no_of_persons: data.no_of_persons || data.number_of_persons || data.persons || '',
              description: data.description || ''
            })
          }
        } else {
          Utility.toastNotifications(res?.message || 'Failed to load booking details', 'Error', 'error')
        }
      } catch (error) {
        console.error('Error loading booking:', error)
        Utility.toastNotifications('Failed to load booking details', 'Error', 'error')
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [slack])

  const clearError = (field) => {
    setErrors((prev) => {
      const newErrors = { ...prev }
      delete newErrors[field]
      return newErrors
    })
  }

  const onChange = (e) => {
    const { name, value } = e.target
    clearError(name)
    setForm((p) => ({ ...p, [name]: value }))
  }

  const pad2 = (n) => String(n).padStart(2, '0')
  const now = new Date()
  const todayStr = now.toISOString().split('T')[0]
  const isSameDate = (a, b) => a && b && a === b
  const toDateTime = (d, t) => (d && t ? new Date(`${d}T${t}`) : null)

  const validate = () => {
    const e = {}
    if (!form.start_date) e.start_date = 'Please enter booking/event start date'
    if (!form.start_time && !form.start_time_24)
      e.start_time = 'Please enter booking/event start time'
    if (!form.end_date) e.end_date = 'Please enter booking/event end date'
    if (!form.end_time && !form.end_time_24)
      e.end_time = 'Please enter booking/event end time'

    const startDT = toDateTime(form.start_date, form.start_time_24)
    const endDT = toDateTime(form.end_date, form.end_time_24)
    if (
      startDT &&
      endDT &&
      form.start_date &&
      form.end_date &&
      form.start_date === form.end_date &&
      endDT < startDT
    )
      e.end_time = 'End must be after or equal to start'
    setErrors(e)
    return Object.keys(e).length === 0
  }

  const onSubmit = async () => {
    if (!validate()) return
    try {
      setSaving(true)
      const {
        start_time_24,
        end_time_24,
        start_h,
        start_m,
        start_ap,
        end_h,
        end_m,
        end_ap,
        ...payload
      } = form
      
      // Set time values
      payload.start_time = start_time_24 || ''
      payload.end_time = end_time_24 || ''
      
      if (!payload.no_of_persons || payload.no_of_persons === '') {
        payload.no_of_persons = '0'
      }

      let storeId = null
      if (props.userEntryType?.user_type === 'staff') {
        if (localStorage.getItem('store_id') == null) {
          localStorage.setItem('store_id', props.userEntryType.branch_id)
        }
        storeId = localStorage.getItem('store_id')
      } else {
        storeId =
          props.userCredentials?.store_id || localStorage.getItem('store_id')
      }
      payload.store_id = storeId

      const res = await BookingEventsController.updateBookingApi(slack, payload)
      if (res?.success) {
        Utility.toastNotifications(
          'Booking updated successfully',
          'Success',
          'success'
        )
        history.push(`/${lng}/booking-events`)
      } else {
        Utility.toastNotifications(
          res?.message || 'Failed to update booking',
          'Error',
          'error'
        )
      }
    } catch (error) {
      console.error('Error updating booking:', error)
      Utility.toastNotifications(
        error?.response?.data?.message || error?.message || 'Failed to update booking',
        'Error',
        'error'
      )
    } finally {
      setSaving(false)
    }
  }

  const onSubmitSafe = async (e) => {
    if (e) e.preventDefault()
    try {
      await onSubmit()
    } catch (err) {
      const msg =
        err?.response?.data?.message || err?.message || 'Failed to save'
      Utility.toastNotifications(msg, 'Error', 'error')
    }
  }

  const err = (key) => errors[key]

  const to12Hour = (hhmm) => {
    if (!hhmm) return ''
    const [hStr, mStr] = hhmm.split(':')
    let h = parseInt(hStr || '0', 10)
    const m = parseInt(mStr || '0', 10)
    const ampm = h >= 12 ? 'PM' : 'AM'
    h = h % 12
    if (h === 0) h = 12
    return `${h}:${m < 10 ? '0' : ''}${m} ${ampm}`
  }

  const handleCancel = () => {
    history.push(`/${lng}/booking-events`)
  }

  // Render loading state
  if (loading) {
    return (
      <Card className='purchase-order-form-card'>
        <Card.Body className='text-center py-5'>
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Loading booking details...</p>
        </Card.Body>
      </Card>
    )
  }

  return (
    <ErrorBoundary title="EditBooking Error">
      <Card className='purchase-order-form-card'>
        <Card.Header className='mb-2'>
          <div className='d-flex justify-content-between align-items-center'>
            <h5 className='mb-1'>
              Edit Booking or Event
            </h5>
            <Button
              variant='secondary'
              size='sm'
              onClick={handleCancel}
            >
              <FontAwesomeIcon icon={faArrowLeft} className='me-1' /> Back
            </Button>
          </div>
        </Card.Header>
        <Card.Body className='p-0'>
          <Form noValidate onSubmit={onSubmitSafe}>
            <div className='p-3'>
              {/* Event Type Section */}
              <Card className='mb-3' style={{ border: 'none', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                <Card.Header className='fw-semibold d-flex align-items-center' style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e9ecef', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', padding: '0.75rem 1rem', color: '#495057' }}>
                  <span style={{ fontSize: '0.95rem' }}>Event Information</span>
                </Card.Header>
                <Card.Body>
                  <Row className='align-items-end'>
                    <Col md={4} className='mb-2'>
                      <Form.Group controlId="formEventType">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faTag} className='me-1' style={{ fontSize: '0.7rem' }} />
                          Event Type <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name='event_type'
                          value={form.event_type}
                          onChange={onChange}
                          style={{ fontSize: '0.85rem' }}
                        >
                          {EVENT_TYPES.map((t) => (
                            <option key={t.value} value={t.value}>
                              {t.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={8}>
                      <Form.Group controlId="formDescription">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faAlignLeft} className='me-1' style={{ fontSize: '0.7rem' }} />
                          Description
                        </Form.Label>
                        <Form.Control
                          as='textarea'
                          rows={1}
                          name='description'
                          value={form.description}
                          onChange={onChange}
                          placeholder='Enter description (optional)'
                          style={{ fontSize: '0.85rem' }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Date & Time Section */}
              <Card className='mb-3' style={{ border: 'none', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                <Card.Header className='fw-semibold d-flex align-items-center' style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e9ecef', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', padding: '0.75rem 1rem', color: '#495057' }}>
                  <span style={{ fontSize: '0.95rem' }}>Date & Time Information</span>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={3} className='mb-2'>
                      <Form.Group controlId="formStartDate">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faCalendar} className='me-1' style={{ fontSize: '0.7rem' }} />
                          Start Date <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type='date'
                          name='start_date'
                          value={form.start_date}
                          onChange={onChange}
                          isInvalid={!!err('start_date')}
                          style={{ fontSize: '0.85rem' }}
                          min={todayStr}
                        />
                        {err('start_date') && (
                          <Form.Control.Feedback type="invalid" style={{ fontSize: '0.7rem' }}>
                            {err('start_date')}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={3} className='mb-2'>
                      <Form.Group controlId="formStartTime">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faClock} className='me-1' style={{ fontSize: '0.7rem' }} />
                          Start Time <span className="text-danger">*</span>
                        </Form.Label>
                        <ClockTimePicker
                          value24={form.start_time_24}
                          onChange={(val24) => {
                            setForm((p) => ({
                              ...p,
                              start_time_24: val24,
                              start_time: to12Hour(val24)
                            }))
                            setErrors((prev) => {
                              const copy = { ...prev }
                              delete copy.start_time
                              return copy
                            })
                          }}
                          placeholder='Select start time'
                        />
                        {!form.start_time && !form.start_time_24 && err('start_time') && (
                          <div className="text-danger" style={{ fontSize: '0.7rem', marginTop: '0.25rem' }}>
                            {err('start_time')}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                
                    <Col md={3} className='mb-2'>
                      <Form.Group controlId="formEndDate">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faCalendar} className='me-1' style={{ fontSize: '0.7rem' }} />
                          End Date <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type='date'
                          name='end_date'
                          value={form.end_date}
                          onChange={onChange}
                          isInvalid={!!err('end_date')}
                          style={{ fontSize: '0.85rem' }}
                          min={form.start_date || todayStr}
                        />
                        {err('end_date') && (
                          <Form.Control.Feedback type="invalid" style={{ fontSize: '0.7rem' }}>
                            {err('end_date')}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={3} className='mb-2'>
                      <Form.Group controlId="formEndTime">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faClock} className='me-1' style={{ fontSize: '0.7rem' }} />
                          End Time <span className="text-danger">*</span>
                        </Form.Label>
                        <ClockTimePicker
                          value24={form.end_time_24}
                          min24={(function() {
                            if (
                              isSameDate(form.end_date, form.start_date) &&
                              form.start_time_24
                            ) {
                              return form.start_time_24
                            }
                            return undefined
                          })()}
                          onChange={(val24) => {
                            setForm((p) => ({
                              ...p,
                              end_time_24: val24,
                              end_time: to12Hour(val24)
                            }))
                            setErrors((prev) => {
                              const copy = { ...prev }
                              delete copy.end_time
                              return copy
                            })
                          }}
                          placeholder='Select end time'
                        />
                        {!form.end_time && !form.end_time_24 && err('end_time') && (
                          <div className="text-danger" style={{ fontSize: '0.7rem', marginTop: '0.25rem' }}>
                            {err('end_time')}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Customer Information Section */}
              <Card className='mb-3' style={{ border: 'none', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                <Card.Header className='fw-semibold d-flex align-items-center' style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e9ecef', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', padding: '0.75rem 1rem', color: '#495057' }}>
                  <span style={{ fontSize: '0.95rem' }}>Customer Information</span>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={3} className='mb-2'>
                      <Form.Group controlId="formName">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faUser} className='me-1' style={{ fontSize: '0.7rem' }} />
                          Name
                        </Form.Label>
                        <Form.Control
                          name='name'
                          value={form.name}
                          onChange={onChange}
                          placeholder='Enter name'
                          style={{ fontSize: '0.85rem' }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3} className='mb-2'>
                      <Form.Group controlId="formEmail">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faEnvelope} className='me-1' style={{ fontSize: '0.7rem' }} />
                          Email
                        </Form.Label>
                        <Form.Control
                          name='email'
                          value={form.email}
                          onChange={onChange}
                          placeholder='Enter email'
                          style={{ fontSize: '0.85rem' }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3} className='mb-2'>
                      <Form.Group controlId="formPhone">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faPhone} className='me-1' style={{ fontSize: '0.7rem' }} />
                          Contact No
                        </Form.Label>
                        <Form.Control
                          name='phone'
                          value={form.phone}
                          onChange={(e) => {
                            Utility.handlePhoneInput(e);
                            onChange(e);
                          }}
                          minLength="10"
                          maxLength="15"
                          placeholder='Enter phone number'
                          style={{ fontSize: '0.85rem' }}
                        />
                      </Form.Group>
                    </Col>
                 
                    <Col md={3} className='mb-2'>
                      <Form.Group controlId="formPersons">
                        <Form.Label style={{ fontSize: '0.8rem', fontWeight: 500, color: '#495057' }}>
                          <FontAwesomeIcon icon={faUsers} className='me-1' style={{ fontSize: '0.7rem' }} />
                          No of Persons
                        </Form.Label>
                        <Form.Control
                          name='no_of_persons'
                          value={form.no_of_persons}
                          placeholder='Enter number of persons'
                          style={{ fontSize: '0.85rem' }}
                          onChange={(e) => {
                            Utility.handlePhoneInput(e);
                            onChange(e);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
             
              <div className="d-flex justify-content-end gap-2 mt-3">
                <Button
                  variant="secondary"
                  onClick={handleCancel}
                  disabled={saving}
                >
                  <FontAwesomeIcon icon={faTimes} className='me-1' />
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Updating...
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faSave} className='me-1' />
                      Update
                    </>
                  )}
                </Button>
              </div>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </ErrorBoundary>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(EditBooking)